exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".collections-container.padding[data-v-ff441982]{padding-bottom:12rem}@media (max-width:767px){.collections-container.padding[data-v-ff441982]{padding-bottom:14rem}}", ""]);

// exports
